import {Component, OnInit} from '@angular/core';
import {Input} from '@angular/core';

import {Product} from '../../../../../models/product';
import {environment} from '../../../../../../../environments/environment';
import {ProductOptionsService} from '../product-options.service';
import {ProductService} from '../../../../../services/product.service';

@Component({
    selector: 'app-product-option-item',
    templateUrl: './product-option-item.component.html',
    styleUrls: ['./product-option-item.component.css']
})

export class ProductOptionItemComponent implements OnInit {

    @Input() public product: Product = new Product();

    @Input('id') id: string;


    image_base = environment.baseCatalogUrl + '/' + environment.baseImagePath;
    isSelected = false;

    constructor(
        public productOptionService: ProductOptionsService,
        public productService: ProductService,
    ) {

    }

    ngOnInit(): void {

        if (parseInt(this.id) == this.product.id) {
            this.isSelected = true;
            this.productService.getProductDetailsFull(this.product.sku).subscribe(product => {
                this.product = product;
                this.productOptionService.EmitOptionItemSelectedEvent(this.product);
            });
            // this.productOptionService.EmitOptionItemSelectedEvent(this.product);
        }

        this.productOptionService.optionItemSelectedEvent.subscribe(result => {

            if (result.id == this.product.id) {
                this.isSelected = true;
            } else {
                this.isSelected = false;
            }
        });

    }

    itemSelected() {

        // this.productOptionService.EmitOptionItemSelectedEvent(this.product);
        this.productService.getProductDetailsFull(this.product.sku).subscribe(product => {
            this.product = product;
            this.productOptionService.EmitOptionItemSelectedEvent(this.product);
        });


    }

}
